import { render, staticRenderFns } from "./traMediciStore.vue?vue&type=template&id=4dbfea56&scoped=true"
import script from "./traMediciStore.vue?vue&type=script&lang=js"
export * from "./traMediciStore.vue?vue&type=script&lang=js"
import style0 from "./traMediciStore.vue?vue&type=style&index=0&id=4dbfea56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbfea56",
  null
  
)

export default component.exports